import { isNumber } from 'lodash'

/**
 * Get a rubric by ID from the rubrics list
 */
export const getRubricById = (rubrics, id) => {
    if (!rubrics || !isNumber(id)) return null
    return rubrics.find(rubric => rubric.id === id) || null
}

/**
 * Get a category by ID from a list of rubrics
 */
export const getCategoryById = (rubrics, categoryId) => {
    if (!Array.isArray(rubrics)) return null

    for (const rubric of rubrics) {
        const category = rubric.categories?.find(c => c.id === categoryId)
        if (category) {
            return {
                ...category,
                rubricId: rubric.id,
                rubricName: rubric.name,
            }
        }
    }

    return null
}

/**
 * Get all categories from a specific rubric
 */
export const getCategoriesByRubricId = (rubrics, rubricId) => {
    if (!Array.isArray(rubrics)) return []
    const rubric = rubrics.find(r => r.id === rubricId)
    return rubric?.categories || []
}

/**
 * Get a QuestionRubric by ID from rubrics that include questionRubrics
 */
export const getQuestionRubricById = (rubrics, questionRubricId) => {
    if (!Array.isArray(rubrics) || !isNumber(questionRubricId)) return null

    for (const rubric of rubrics) {
        const qr = rubric.questionRubrics?.find(qr => qr.id === questionRubricId)
        if (qr) {
            return {
                ...qr,
                rubricId: rubric.id,
                rubricName: rubric.name,
            }
        }
    }

    return null
}

/**
 * Selectors for fetchRubrics query
 */
export const fetchRubricsSelectors = {
    byId: (arg, result) => ({
        ...result,
        data: getRubricById(result?.data, arg.id),
    }),
    pattern: (arg, result) => ({
        ...result,
        data: getCategoryById(result?.data, arg.patternId),
    }),
    categoriesByRubricId: (arg, result) => ({
        ...result,
        data: getCategoriesByRubricId(result?.data, arg.rubricId),
    }),
    questionRubric: (arg, result) => ({
        ...result,
        data: getQuestionRubricById(result?.data, arg.questionRubricId),
    }),
}
